import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgSmokeDetector extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 225 300" height={size}>
                <path
                    d="M224.36 175.65c-3.44-44.74-24.27-72.78-42.65-97.52-17-22.9-31.71-42.69-31.71-71.86A6.26 6.26 0 0 0 146.61.7a6.19 6.19 0 0 0-6.49.48C112.5 20.93 89.5 54.21 81.44 86c-4.68 18.53-6 39-6.31 54.79a6 6 0 0 1-9.26 4.87c-17.78-11.17-22.13-39.89-22.18-40.25a6.25 6.25 0 0 0-8.92-4.74c-1.34.65-32.81 16.64-34.64 80.48C0 183.27 0 185.4 0 187.53A112.63 112.63 0 0 0 112.5 300a.86.86 0 0 0 .25 0h.08A112.63 112.63 0 0 0 225 187.5c0-3.12-.64-11.85-.64-11.85zM75 247.55v-2.44c.07-2.51.25-4.8.51-6.89a6 6 0 0 1 9.89-3.69l.23.21c7.58 7 20 1.58 20.3-8.74a101 101 0 0 1 2.31-20.47 55.27 55.27 0 0 1 6.1-14.72 6 6 0 0 1 10.43.28 124.56 124.56 0 0 0 9 14.11c7.23 10.28 14.71 20.9 16 39 .08 1.07.16 2.15.16 3.31 0 22-16.82 39.94-37.5 39.94S75 269.57 75 247.55z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(SvgSmokeDetector);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgSmokeDetector.js